import React from 'react';
import SidebarLayout from '../components/Layout/SidebarLayout';
import ChatBox from '../components/Chat/ChatBox';

const Chat = () => {
  return (
    <SidebarLayout>
    
      <ChatBox />
    </SidebarLayout>
  );
};

export default Chat;